/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_PARTIAL_PAYMENT_USERS = gql`
  query GetUserAdvancedSearch(
    $options: GetManyOptions
    $filter: UserAdvancedSearchFilterInput
  ) {
    getUserAdvancedSearch(options: $options, filter: $filter) {
      content {
        _id
        paymentStats
        createdAt
        totalAmount
        costumeID
        CostumeType {
          name
        }
        User {
          vuid
        }
        Section {
          name
        }
        PayOrders {
          amountPaid
        }
      }
      count
      skip
      limit
    }
  }
`;

export const GET_PARTIAL_PAYMENT_USERS_ADMIN = gql`
  query GetUserAdvancedSearch(
    $options: GetManyOptions
    $filter: UserAdvancedSearchFilterInput
  ) {
    getUserAdvancedSearch(options: $options, filter: $filter) {
      content {
        _id
        costumeID
        ReferalUsers {
          email
          role
          fullName
        }
        paymentStats
        User {
          fullName
          email
          _id
          vuid
        }
        createdAt
        totalAmount
        CostumeType {
          name
        }
        Section {
          name
        }
        PayOrders {
          amountPaid
        }
      }
      count
      skip
      limit
    }
  }
`;
